<template>
  <div class="printable-content simple-paper text-sm">
    <!-- header informations -->
    <div class="grid grid-cols-2 mb-8 border-b border-slate-300 pb-4">
      <!-- uttrly informations -->
      <div>
        <div class="mb-4">
          <span class="block font-bold text-md mb-3">Uttrly</span>
          <span class="block mb-2">11810 Grand Park Ave, Suite 500</span>
          <span class="block mb-2">North Bethesda, MD 20852</span>
          <span class="block mb-2">202.681.0825</span>
          <span class="block">portal-admin@uttrly.com</span>
        </div>

        <div class="text-primary-700 font-semibold mb-4 text-2xl">
          <span>Purchase Order</span>
        </div>

        <!-- vendor informations -->
        <div>
          <span v-if="vendor?.name" class="block mb-1 font-bold">{{ vendor.name }}</span>
          <span v-if="vendor?.address" class="block mb-1">{{ vendor.address }}</span>
        </div>
      </div>

      <!-- logo and purchase order header informations -->
      <div>
        <div class="flex justify-end mb-7">
          <img
            :src="logo"
            alt="Uttrly"
          />
        </div>
        <div class="text-right">
          <div class="grid grid-cols-4 gap-2">
            <span class="font-bold col-span-3">PO#</span>
            <span>{{ purchaseOrder.purchaseOrderId }}</span>
          </div>

          <div class="grid grid-cols-4 gap-2">
            <span class="font-bold col-span-3">DATE</span>
            <span>{{ getLocalDate(purchaseOrder.date) }}</span>
          </div>

          <div class="grid grid-cols-4 gap-2">
            <span class="font-bold col-span-3">TERMS</span>
            <span>Net 30</span>
          </div>
        </div>
      </div>
    </div>

    <!-- purchase order items -->
    <div>
      <BaseTable
        :items="purchaseOrder.items"
        :fields="purchaseOrderItemFields"
        :show-footer="true"
        class="mt-5"
      >
        <template #cost-data="{ row }">
          {{ currency(row.cost) }}
        </template>
        <template #total-data="{ row }">
          {{ currency(row.quantity * row.cost) }}
        </template>
        <template #description-data="{ row }">
          <span class="!text-wrap">{{ row.description }}</span>
        </template>

        <template #footer>
          <div class="flex items-center justify-between gap-2">
            <div class="flex-grow">
              <span class="text-slate-500 text-xs">Thank you for your business and have a great day</span>
            </div>

            <div>
              <div class="flex items-center justify-end gap-2">
                <span class="font-bold">Total:</span>
                <span>{{ currency(purchaseOrder.total) }}</span>
              </div>
            </div>
          </div>
        </template>
      </BaseTable>
    </div>
  </div>
</template>

<script lang="ts" setup>
import logo from '@/assets/images/logo.png'
import { PurchaseOrder } from '@/models/purchaseOrder'
import { Vendor } from '@/models/vendor'
import { currency, getLocalDate } from '@/utils'
import { PropType } from 'vue'
import BaseTable from '@/components/base/BaseTable.vue'


defineProps({
  vendor: {
    type: Object as PropType<Vendor>,
    required: true
  },
  purchaseOrder: {
    type: Object as PropType<PurchaseOrder>,
    required: true
  },
})

const purchaseOrderItemFields = [
  { key: 'name', label: 'Items' },
  { key: 'description', label: 'Description' },
  { key: 'cost', label: 'Price' },
  { key: 'quantity', label: 'Quantity' },
  { key: 'total', label: 'Total' }
]


</script>


<style lang="scss" scoped>
.printable-content {
  width: 200mm !important; /* Largeur A4 */
  padding: 5mm !important; /* Marges */
  /* min-height: 257mm !important; Hauteur A4 */
  background: white;
}

.simple-paper {
  border: 0.7px solid #ccc;
  padding: 20px;
}
</style>

